// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export default {
    IGNORE_CHANNEL_MENTIONS_ON: 'on',
    IGNORE_CHANNEL_MENTIONS_OFF: 'off',
    IGNORE_CHANNEL_MENTIONS_DEFAULT: 'default',
};
